import React, { useState, useEffect , useRef } from 'react';
import { classNames } from 'primereact/utils';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
//import { Clientes } from '../api/ProductService.tsx';
import { getClientes,addCliente , updateCliente, eliminarCliente ,getNumeroNextCliente} from '../api/clientesService';//getClientes
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar'; 
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import { InputTextarea } from 'primereact/inputtextarea';
import { Dropdown } from 'primereact/dropdown';
import { RadioButton } from 'primereact/radiobutton';
import { Tag } from 'primereact/tag';
import { InputMask } from "primereact/inputmask";

function MainClientes() {
    //console.log('MainClientes.jsx'); // Para verificar que se está cargando este componente 
   let emptyClientes = {
        _id: null,        
        noCliente: null,
        razonSocial: '',
        regimen: '',
        ruc: '',
        domicilio: '',
        departamento: '',
        pais: '',
        codigoPostal: null,
        contribuyente:'',
        regimen:'',
        telefono:'',
        correo:'',
        activo:true,
        contacto:[],
    };
    

    const paises = [
    { name: 'México', code: 'MX' },
    { name: 'Nicaragua', code: 'NIC' },
    { name: 'EUA', code: 'US' }];

    const contribuyentes=[
    { name:'Persona Natural'},
    { name:'Persona Juridica'}];
    
    const [selectedContribuyente , setSelectedContribuyente]=useState(null);

    const regimen=[
    { name:'Cuota Fija'},
    { name:'General'}];

    const [selectedRegimen, setSelectedRegimen]=useState(null);

    const [clientes, setClientes] = useState([]);
    const [cliente, setCliente] = useState(emptyClientes);
    const [esNuevoCliente, setEsNuevoCliente] = useState(true); // true: creando | false: editando    

    const [deleteClienteDialog, setDeleteClienteDialog] = useState(false);
    const [deleteClientesDialog, setDeleteClientesDialog] = useState(false);

    const [clienteDialog, setClienteDialog] = useState(false);    
    const [submitted, setSubmitted] = useState(false);

    const [selectedClientes, setSelectedClientes] = useState(null);
    const toast = useRef(null);
    const dt = useRef(null);

    // const [contactoDialog, setContactoDialog] = useState(false);  
    const [first, setFirst] = useState(0); // índice inicial de la página
    const rows = 10; // registros por página 

    const [contactoDialog, setContactoDialog] = useState([{ nombre: '', email: '', telefonoPrimario: '', tipoTelefono:'', referencia:'' , puestoarea:''}]);

    const [contactoDialogVisible, setContactoDialogVisible] = useState(false); // <-- visibilidad
    const [contactos, setContactos] = useState([]); // <-- contactos temporales del cliente

    useEffect(() => {
    const fetchData = async () => {
    const data = await getClientes();
      setClientes(data);
    };
        fetchData();
    }, []);

    const openNew =async () => {

    setCliente(emptyClientes);
    setSubmitted(false);
    setClienteDialog(true);    
    setEsNuevoCliente(true);
        
    try{
        const data = await getNumeroNextCliente(); // consulta al backend
        setCliente((prev) => ({ ...prev, noCliente: data.clienteId })); // asigna el noCliente
        //console.log(data);
        setClienteDialog(true);
    }
    catch(error)
    {
        toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "No se pudo generar el número de cliente",
        life: 3000,
        });
    }};

    const hideDialog = () => {
    setCliente(emptyClientes);
    setSubmitted(false);
    setClienteDialog(false);   
    // 🔹 Limpia los dropdowns
    setSelectedContribuyente(null);
    setSelectedRegimen(null);    
    };

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const leftToolbarTemplate = () => {
        return (
            <div className="flex flex-wrap gap-2">
                <Button label="Agregar Cliente" icon="pi pi-plus" severity="success" onClick={openNew} />
                <Button label="Exportar" icon="pi pi-upload" className="p-button-help" onClick={exportCSV}/>
                {/* <Button label="Delete" icon="pi pi-trash" severity="danger" onClick={confirmDeleteSelected} disabled={!selectedProducts || !selectedProducts.length} /> */}
            </div>
        );
    };
    
    
    /*Guardar cliente*/
    const saveCliente = async () => {
    setSubmitted(true);

    if (cliente.razonSocial && cliente.ruc) {        
    try{
            
    let _cliente = { ...cliente };
    // 🔹 Asigna valores de dropdowns al cliente antes de guardar
    _cliente.contribuyente = selectedContribuyente ? selectedContribuyente.name : '';
    _cliente.regimen = selectedRegimen ? selectedRegimen.name : '';
    
    let _clientes = [...clientes];

    if (cliente._id) {
        const updated = await updateCliente(_cliente._id, _cliente);
        const index = findIndexById(_cliente._id);
        _clientes[index] = updated;
    } 
    else {
        const inserted = await addCliente(_cliente);
        _clientes.push(inserted);
    }
        const dataActualizada = await getClientes();   
        setClientes(dataActualizada);
        setClienteDialog(false);
        setCliente(emptyClientes);
        setSelectedContribuyente(null); // 🔹 limpia también al guardar
        setSelectedRegimen(null);
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Cliente guardado', life: 3000 });
    }// fin del try
    catch (error) {        
       //console.error('Error al guardar cliente2:', error.response.data.error);
      toast.current.show({ severity: 'error', summary: 'Error', detail: error.response.data.error, life: 3000 });    
    }}};

    const deleteCliente = async ()  => {
    try {
        await eliminarCliente(cliente._id); // usa el _id de Mongo
        const dataActualizada = await getClientes();
        setClientes(dataActualizada);
        setDeleteClienteDialog(false);
        setCliente(emptyClientes);
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Cliente eliminado', life: 3000 });
    } catch (error) {
        console.error('Error al eliminar cliente:', error);
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'No se pudo eliminar el cliente', life: 3000 });
    }};

    /* Editar la informacion del cliente */    
    const editCliente = (cliente) => {
        setCliente({ ...cliente });// importante conservar el _id
        setClienteDialog(true);
        setEsNuevoCliente(false);        
        // 🔹 Asigna valores a los dropdowns si existen
        setSelectedContribuyente(contribuyentes.find(c => c.name === cliente.contribuyente) || null);
        setSelectedRegimen(regimen.find(r => r.name === cliente.regimen) || null);
    };

    const editContact = (clienteData) => {
        setCliente({ ...clienteData });
        setContactos(clienteData.contacto || []); // carga los contactos existentes
        // setContactoDialogVisible(true); // muestra el diálogo      
        setContactoDialog(clienteData.contacto && clienteData.contacto.length > 0 
        ? clienteData.contacto 
        : [{ nombre: '', email: '', telefonoPrimario: '', tipoTelefono: '', referencia: '' }]);
        setContactoDialogVisible(true);
    };

    const confirmDeleteCliente = (cliente) => {
        setCliente(cliente);
        setDeleteClienteDialog(true);
    };

    const deleteSelectedClientes = () => {

        let _clientes = clientes.filter((val) => !selectedClientes.includes(val));
        setClientes(_clientes);
        setDeleteClientesDialog(false);
        setSelectedClientes(null);
        toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Products Deleted', life: 3000 });
    };
  
    const hideDeleteClienteDialog = () => {
        setDeleteClienteDialog(false);
    };

    const hideDeleteClientesDialog = () => {
        setDeleteClientesDialog(false);
    };

    const findIndexById = (_id) => {
        return clientes.findIndex((c) => c._id === _id);};

    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _cliente = { ...cliente };
        _cliente[`${name}`] = val;
        setCliente(_cliente);
    };

    const clienteDialogFooter = (
        <React.Fragment>
            <Button label="Cancelar" icon="pi pi-times" severity='danger'  onClick={hideDialog} />
            <Button label="Guardar" icon="pi pi-check" severity='success'  onClick={saveCliente} />
        </React.Fragment>
    );

    const actionBodyTemplate = (rowData) => {        
        return (
            <React.Fragment>
                <Button icon="pi pi-pencil" rounded  className="mr-1" onClick={() => editCliente(rowData)} />
                <Button icon="pi pi-trash" rounded  severity="danger" onClick={() => confirmDeleteCliente(rowData)} />
            </React.Fragment>
        );
    };

    const contactBodyTemplate = (rowData) => {
        const numContactos = rowData.contacto ? rowData.contacto.length : 0;
        return (
            <React.Fragment>
                 <Button icon="pi pi-users" rounded  className="mr-2" severity="success" onClick={() => editContact(rowData)}  label={`${numContactos} ${numContactos !== 1 ? '' : ''}`} /> 
                {/* <Button icon="pi pi-trash" rounded outlined severity="danger" onClick={() dialo=> confirmDeleteCliente(rowData)} /> */}

            </React.Fragment>
        );
    };
     
    const deleteClienteDialogFooter = (
        <React.Fragment>
            <Button label="No" icon="pi pi-times" outlined onClick={hideDeleteClienteDialog} />
            <Button label="Si" icon="pi pi-check" severity="danger" onClick={deleteCliente} />
        </React.Fragment>
    );

    const deleteClientesDialogFooter = (
        <React.Fragment>
            <Button label="No" icon="pi pi-times" outlined onClick={hideDeleteClientesDialog} />
            <Button label="Si" icon="pi pi-check" severity="danger" onClick={deleteSelectedClientes} />
        </React.Fragment>
    );
     // plantilla para numerar consecutivamente
    const rowNumberTemplate = (rowData, options) => {
        return first + options.rowIndex + 1;
    };
    
    const statusBodyTemplate = (rowData) => {
        return <Tag severity={rowData.activo ? "success" : "danger" } >{rowData.activo ? "Activo" : "Inactivo"}</Tag>;
    };

    const handleChangeContact = (index, field, value) => {
        const updated = [...contactoDialog];
        updated[index][field] = value;
        setContactoDialog(updated);
    };

    const handleAddContact = () => {
        setContactoDialog([...contactoDialog, {  nombre: '', email: '', telefonoPrimario: '', tipoTelefono:'', referencia:'' ,puestoarea:'' }]);
    };

    const handleRemoveContact = (index) => {
    const updated = contactoDialog.filter((_, i) => i !== index);
    setContactoDialog(updated);
    };

    const handleSubmitContact = async  () => {
    //onSave(contactoDialog);
    //onHide();
    // setContactoDialog([{ nombre: '', email: '', telefonoPrimario: '', tipoTelefono:'', referencia:''  }]); // Limpiar después de guardar
    try {
    // Asigna la lista de contactos al cliente actual
    const clienteActualizado = { ...cliente, contacto: contactoDialog };

    // Guarda el cliente actualizado en Mongo
    if (clienteActualizado._id) {
      await updateCliente(clienteActualizado._id, clienteActualizado);
      toast.current.show({
        severity: 'success',
        summary: 'Éxito',
        detail: 'Contactos guardados',
        life: 3000,
      });
    }

    // Refresca los datos
    const dataActualizada = await getClientes();
    setClientes(dataActualizada);

    // Cierra y limpia el diálogo
    setContactoDialogVisible(false);
    setContactoDialog([{ nombre: '', email: '', telefonoPrimario: '', tipoTelefono: '', referencia: '', puestoarea:'' }]);
    } catch (error) {
    console.error('Error al guardar contactos:', error);
    toast.current.show({
      severity: 'error',
      summary: 'Error',
      detail: 'No se pudieron guardar los contactos',
      life: 3000,
    });
  }
  };


    return (
    <>
    <Toast ref={toast} />
    <section className="mission-section" id="clientes">
        
        <div class="layout-content-inner">
            <div>
                <nav class="layout-breadcrumb">
                    <ol>
                        <li><a href="/"><i class="pi pi-home"></i></a></li>
                        <li class="layout-breadcrumb-chevron"> / </li>
                        <li>Clientes</li>
                    </ol>
                </nav>
            </div>

            <div className="card">
                <Toolbar className="mb-4" right={leftToolbarTemplate} ></Toolbar>

                <DataTable  ref={dt} value={clientes} paginator rows={rows}  first={first}  stripedRows selectionMode="single"
                
                 onPage={(e) => setFirst(e.first)} // actualiza el índice inicial al cambiar de página
                //</div>tableStyle={{ minWidth: '50rem' }}
                >
                    <Column header="#" body={rowNumberTemplate} style={{ width: "50px", textAlign: "center" }} />
                    {/* <Column field="noCliente" header="#Codigo Cliente"></Column> */}
                    <Column field="razonSocial" header="Razon Social"></Column>
                    <Column field="regimen" header="Regimen"></Column>
                    <Column field="ruc" header="RUC"></Column>
                    <Column field="pais" header="Pais"></Column>
                    <Column field="codigoPostal" header="Codigo Postal"></Column>
                    <Column field="activo" header="Estado"   body={statusBodyTemplate}></Column>                   
                    <Column header="Acciones" body={actionBodyTemplate} exportable={false} ></Column>
                    <Column header="Contactos"  body={contactBodyTemplate} exportable={false} ></Column>
                </DataTable>
            </div>

            <Dialog visible={clienteDialog}  header="Datos del Cliente" modal className="p-fluid" footer={clienteDialogFooter}  onHide={hideDialog} >
                <div className="formgrid grid">
                    <div className="field col-2">
                        <label htmlFor="noCliente" className="font-bold"  >#Cliente </label>
                            <InputText id="noCliente" value={cliente.noCliente} onChange={(e) => onInputChange(e, 'noCliente')}  disabled={!esNuevoCliente} required autoFocus className={classNames({ 'p-invalid': submitted && !cliente.noCliente})} />
                            {submitted && !cliente.noCliente && <small className="p-error"></small>}
                    </div>
                    <div className="field col-10">
                        <label htmlFor="regimen" className="font-bold">Razon Social</label>
                        <InputText id="razonSocial" value={cliente.razonSocial} onChange={(e) => onInputChange(e, 'razonSocial')} required autoFocus className={classNames({ 'p-invalid': submitted && !cliente.razonSocial})} />
                        {submitted && !cliente.razonSocial && <small className="p-error">La razon socia es requerida.</small>}
                    </div>
                     
                </div>
                <div className="formgrid grid">
                    <div className="field col-4">
                        <label htmlFor="regimen" className="font-bold">Tipo Contribuyente</label>
                        {/* <InputText id="regimen" value={cliente.regimen} onChange={(e) => onInputChange(e, 'regimen')} required rows={3} cols={20} /> */}
                        <Dropdown value={selectedContribuyente} onChange={(e)=> setSelectedContribuyente(e.value)} options={contribuyentes} optionLabel="name"/>
                    </div>
                    <div className="field col-4">
                        <label htmlFor="regimen" className="font-bold">Tipo de regimen</label>
                        {/* <InputText id="regimen" value={cliente.regimen} onChange={(e) => onInputChange(e, 'regimen')} required rows={3} cols={20} /> */}
                        <Dropdown value={selectedRegimen} onChange={(e)=> setSelectedRegimen(e.value)} options={regimen} optionLabel="name"/>
                    </div>
                    <div className="field col-4">
                        <label htmlFor="ruc" className="font-bold">RUC</label>
                        <InputText id="ruc" value={cliente.ruc}  maxlength="14" onChange={(e) => onInputChange(e, 'ruc')} required rows={3} cols={20} />                       
                    </div>
                </div>
                <div className="formgrid grid">
                    <div className="field col-8">
                        <label htmlFor="coreo" className="font-bold block mb-2">Correo</label>
                        <InputText  type="email"  placeholder="Ingresa tu correo"  required value={cliente.correo} onChange={(e) => onInputChange(e, 'correo')}></InputText>
                        {/* <InputText id="telefono" mask="(999) 999-9999" placeholder="(999) 999-9999"></InputText> */}
                    </div>
                    <div className="field col-4">
                        <label htmlFor="telefono" className="font-bold block mb-2">Telefono</label>
                        <InputMask id="telefono" mask="(999) 999-9999" placeholder="(999) 999-9999" value={cliente.telefono} onChange={(e) => onInputChange(e, 'telefono')}></InputMask>
                    </div>
                </div>
                <div className="formgrid grid">
                    <div className="field col-12">
                    <label htmlFor="domicilio" className="font-bold">Domicilio</label>
                    <InputText id="domicilio" value={cliente.domicilio} onChange={(e) => onInputChange(e, 'domicilio')} required rows={3} cols={20} />
                </div>
                </div> 

               <div className="formgrid grid">
                
                    <div className="field col-4">
                        <label htmlFor="pais" className="font-bold">Pais</label>
                        <Dropdown id="pais" value={cliente.pais} onChange={(e) => onInputChange({ target: { value: e.value } }, 'pais')} options={paises}
                                optionLabel="name" placeholder="Seleccione un país" optionValue="name" dataKey="name"
                                className={classNames({ 'p-invalid': submitted && !cliente.pais })}/>
                        {submitted && !cliente.pais && <small className="p-error">El país es requerido.</small>}
                    </div>

                    <div className="field col-4">
                        <label htmlFor="codigoPostal" className="font-bold">Codigo Postal</label>
                        <InputText id="codigoPostal" value={cliente.codigoPostal} onChange={(e) => onInputChange(e, 'codigoPostal')} required rows={3} cols={20} maxlength="5"/>
                    </div>
                </div>
               
                <div className="formgrid grid">
                <div className="field col-8">
                    <label htmlFor="departamento" className="font-bold"> Departamento</label>
                    <InputText id="departamento" value={cliente.departamento} onChange={(e) => onInputChange(e, 'departamento')} required rows={3} cols={20} />
                </div>
                <div className="field col-4">
                    <label htmlFor="departamento" className="font-bold">Estatus</label>
                     <div className="flex flex-wrap gap-3">
                         <div className="flex align-items-center">
                              <input type="checkbox" name="activo"  onChange={(e) => onInputChange({ target: { value: e.target.checked } }, 'activo')} checked={cliente.activo || false} />
                                <label htmlFor="activo" className="ml-2">Activo</label>
                     </div>
                         </div>              
                </div>
                </div>
            </Dialog>
            <Dialog   visible={contactoDialogVisible}
            // visible={contactoDialog}   style={{ width: '32rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Contactos" modal className="p-fluid" 
            //footer={clienteDialogFooter} 
            // onHide={}
          
            style={{ width: '40rem' }}
            header="Contactos"
            modal
            className="p-fluid"
            onHide={() => setContactoDialogVisible(false)}
            >

        {/* <div className="p-fluid"> */}
        {contactoDialog.map((contacto, index) => (
          <div className="card" key={index} style={{ marginBottom: '2rem' }}>            
            <div class="formgrid grid">
                <div className="field col-12 "><label><strong>Nombre</strong></label>
                    <InputText placeholder="" value={contacto.nombre}  onChange={(e) => handleChangeContact(index, 'nombre', e.target.value)} />
                </div>
                <div className="field col-12 md:col-8"> <label><strong>Correo</strong></label>
                     <InputText placeholder=""  value={contacto.email}  onChange={(e) => handleChangeContact(index, 'email', e.target.value)} />
                </div>
                <div className="field col-12 md:col-4"></div>
                <div className="field col-5 "><label><strong>Tipo de telefono</strong></label>
                    <div className="col  align-items-center">
                    <RadioButton inputId={`tipo1-${index}`} name={`tipoTelefono-${index}`} value="fijo" onChange={(e) => handleChangeContact(index, 'tipoTelefono', e.value)} checked={contacto.tipoTelefono === 'fijo'} />
                    <label htmlFor={`tipo1-${index}`} className="ml-2">Fijo </label>
                    {/* </div>
                    <div className="  col"> */}
                    <RadioButton inputId={`tipo2-${index}`} name={`tipoTelefono-${index}`} value="movil" onChange={(e) => handleChangeContact(index, 'tipoTelefono', e.value)} checked={contacto.tipoTelefono === 'movil'} />
                    <label htmlFor={`tipo2-${index}`} className="ml-2">Móvil</label>   
                </div>                    
                </div>
                <div className="field col-12 md:col-7"><label htmlFor="email"><strong>Telefono</strong></label>
                    <InputMask  mask="99-999999" placeholder="" value={contacto.telefonoPrimario} onChange={(e) => handleChangeContact(index, 'telefonoPrimario', e.target.value)}  />
                </div>
                <div className="field col-12 md:col-6"><label htmlFor="referencia"><strong>Referencia</strong></label>
                    <InputText  placeholder="" value={contacto.referencia} onChange={(e) => handleChangeContact(index, 'referencia', e.target.value)}  />
                </div>
                <div className="field col-12 md:col-6"><label htmlFor="puestoArea"><strong>Puesto o area</strong></label>
                    <InputText  placeholder="" value={contacto.puestoarea} onChange={(e) => handleChangeContact(index, 'puestoarea', e.target.value)}  />
                </div>

            </div>            
            <div className="flex flex-row-reverse flex-wrap">
              <Button   icon="pi pi-trash"  className="p-button-danger"  onClick={() => handleRemoveContact(index)}  />
            </div>            
          </div>
        ))}
 
       
      {/* </div> */}
             <h5></h5>
      <div className="formgrid grid">
        <div className="field col-12 md:col-6">
        {/* <Button label="Cancelar" icon="pi pi-times"  // onClick={onHide} 
           severity="danger" /> */}
            <Button  label="Agregar contacto" severity=""  icon="pi pi-plus"  lassName="p-button-outlined p-button-sm"   onClick={handleAddContact}  />
        </div>
        <div className="field col-12 md:col-6">   
            <Button label="Guardar" icon="pi pi-check"  severity="success" onClick={handleSubmitContact} autoFocus />
        </div>
      </div>
      
    </Dialog>

            <Dialog visible={deleteClienteDialog} style={{ width: '32rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Confirmar" modal footer={deleteClienteDialogFooter} onHide={hideDeleteClienteDialog}>
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    {cliente && (
                        <span>
                            ¿Seguro de eliminar el registro <b>{cliente.razonSocial}</b>?
                        </span>
                    )}
                </div>
            </Dialog>

            <Dialog visible={deleteClientesDialog} style={{ width: '32rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Confirmar" modal footer={deleteClientesDialogFooter} onHide={hideDeleteClientesDialog}>
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    {cliente && <span>Are you sure you want to delete the selected products?</span>}
                </div>
            </Dialog>
        </div>
    </section>
        </>
      
    );
}
export default MainClientes;        